import React from 'react';
import { Document } from '@react-pdf/renderer';
import { Page1 } from './Page1';
import { Page2 } from './Page2';

const ContractPF = ({ data, type }) => {
    return (
        <>
            <Page1 data={data} type={type} />
        </>
    );
};

export default ContractPF;
